<template>
  <header
    :class="{
      landing:
        !$store.state.main.mallType &&
        $route.params.path1 !== 'about-us' &&
        $route.params.path1 !== 'card-loyal'
    }"
    @mousemove="cursorChange(true)"
    @mouseleave="cursorChange(false)"
  >
    <div
      v-if="
        $store.state.main.mallType ||
          $route.params.path1 == 'about-us' ||
          $route.params.path1 == 'card-loyal'
      "
      class="default-header"
    >
      <div class="fixed" :class="{ scrolled: scrolled }">
        <div class="default-header__top between al-center flex container">
          <div class="default-header__top__top-left flex al-center">
            <div
              v-if="$route.params.path1 != 'about-us'"
              class="burger"
              :class="{ open: openMenu }"
              @click="openMenu = !openMenu"
            >
              <div class="burger-item"></div>
              <div class="burger-item"></div>
            </div>
            <router-link
              tag="div"
              :to="`/${$store.state.main.locale}/`"
              v-if="
                $route.params.path1 == 'about-us' ||
                  $route.params.path1 == 'card-loyal'
              "
              class="back bold uppercase pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="7.857"
                height="10"
                viewBox="0 0 7.857 10"
              >
                <path
                  id="Icon_material-play-arrow"
                  data-name="Icon material-play-arrow"
                  d="M19.857,7.5v10L12,12.5Z"
                  transform="translate(-12 -7.5)"
                  fill="#1a1a1a"
                />
              </svg>
              {{ $fn.tr("უკან") }}
            </router-link>
            <div class="lang flex al-center" :class="{ active: languageOpen }">
              <div
                class="lang-row flex-box"
                @click="languageOpen = !languageOpen"
              >
                <div class="selected-lang bold uppercase">
                  {{
                    _.get($store.state.main, "locale") === "ge" ? "Geo" : "Eng"
                  }}
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="7.857"
                  viewBox="0 0 10 7.857"
                >
                  <path
                    id="Icon_material-play-arrow"
                    data-name="Icon material-play-arrow"
                    d="M12,7.5v10l7.857-5Z"
                    transform="translate(17.5 -12) rotate(90)"
                    fill="#4d4d4f"
                  />
                </svg>
              </div>

              <div class="change-lang-options" @click="changeLang">
                <router-link
                  :to="''"
                  tag="div"
                  class="selected-lang bold uppercase"
                >
                  {{
                    _.get($store.state.main, "locale") === "ge" ? "Eng" : "Geo"
                  }}
                </router-link>
              </div>
            </div>
            <a
              :href="_.get(get360['button'], 'url')"
              target="_blank"
              class="link-360 bold"
            >
              {{ _.get(get360["button"], "title") }}
              <span class="bold">&#176;</span>
            </a>
            <div
              class="default-header__search pointer"
              @click="toggle_search()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <path
                  id="Path_3023"
                  data-name="Path 3023"
                  d="M19.556,17.383,15.433,13.26a8.231,8.231,0,0,0,1.491-4.8,8.312,8.312,0,0,0-.667-3.287A8.287,8.287,0,0,0,11.749.67a8.433,8.433,0,0,0-6.575,0A8.286,8.286,0,0,0,.667,5.177a8.433,8.433,0,0,0,0,6.574,8.289,8.289,0,0,0,4.507,4.507,8.315,8.315,0,0,0,3.287.667,8.232,8.232,0,0,0,4.8-1.49l4.123,4.111A1.428,1.428,0,0,0,18.462,20a1.538,1.538,0,0,0,1.094-2.62Zm-7.29-5.114a5.185,5.185,0,0,1-3.8,1.581,5.186,5.186,0,0,1-3.8-1.581,5.185,5.185,0,0,1-1.581-3.8,5.186,5.186,0,0,1,1.581-3.8,5.185,5.185,0,0,1,3.8-1.581,5.187,5.187,0,0,1,3.8,1.581,5.185,5.185,0,0,1,1.581,3.8A5.186,5.186,0,0,1,12.266,12.269Z"
                  transform="translate(0 -0.003)"
                  fill="#4d4d4f"
                />
              </svg>
            </div>
          </div>

          <svg-components
            v-if="_.get($store.state.main, 'locale') === 'ge'"
            @click.native="goToHome"
            class="about-us-logo pointer"
            name="logo"
          />
          <svg-components
            v-if="_.get($store.state.main, 'locale') === 'en'"
            @click.native="goToHome"
            class="about-us-logo pointer"
            name="eng-logo"
          />

          <svg-components
            @click.native="goToHome"
            class="about-us-logo mobile-logo pointer"
            :name="`mobile_logo_${_.get($store.state.main, 'locale')}`"
          />

          <div class="default-header__top__top-right flex al-center">
            <CardsDropdown />
            <router-link
              v-if="
                $route.params.path1 !== 'about-us' &&
                  $route.params.path1 !== 'card-loyal'
              "
              tag="div"
              :to="mallUrl"
              class="location uppercase bold"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.505"
                height="16"
                viewBox="0 0 15.505 16"
              >
                <path
                  id="Path_3184"
                  data-name="Path 3184"
                  d="M78.062,85.233v3.242h4.764l-4.4,4.545,2.371,2.447L85.2,90.922v4.916h3.142V85.233Zm0-5.395v3.243H90.425V95.838h2.268a.889.889,0,0,0,.875-.9V80.665a.815.815,0,0,0-.8-.827Z"
                  transform="translate(-78.062 -79.838)"
                  fill="#4d4d4f"
                />
              </svg>
              <span class="desktop-switcher">
                {{
                  $route.params.path1 == "saburtalo"
                    ? $fn.tr("სითი მოლი გლდანი")
                    : $fn.tr("სითი მოლი საბურთალო")
                }}
              </span>

              <span class="mobile-switcher">
                {{
                  $route.params.path1 == "saburtalo"
                    ? $fn.tr("გლდანი")
                    : $fn.tr("საბურთალო")
                }}
              </span>
            </router-link>
            <div class="relative choose-mall" v-else>
              <div
                @click="openMallDropdown = !openMallDropdown"
                class="label pointer"
                :class="{ open: openMallDropdown }"
              >
                <span
                  v-if="$mq != 'phone' && $mq != 'xs'"
                  class="bold uppercase"
                >
                  {{ $fn.tr("აირჩიეთ მოლი") }}
                </span>
                <span v-else class="bold uppercase">
                  {{ $fn.tr("მოლი") }}
                </span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="7.857"
                  viewBox="0 0 10 7.857"
                >
                  <path
                    id="Icon_material-play-arrow"
                    data-name="Icon material-play-arrow"
                    d="M12,7.5v10l7.857-5Z"
                    transform="translate(17.5 -12) rotate(90)"
                    fill="#4d4d4f"
                  />
                </svg>
              </div>
              <slide-up-down
                :active="openMallDropdown"
                :duration="600"
                class="dropdown"
              >
                <router-link
                  tag="div"
                  :to="`/${this.$store.state.main.locale}/saburtalo`"
                  class="location uppercase bold"
                >
                  {{ $fn.tr("სითი მოლი საბურთალო") }}
                </router-link>
                <router-link
                  tag="div"
                  :to="`/${this.$store.state.main.locale}/gldani`"
                  class="location uppercase bold"
                >
                  {{ $fn.tr("სითი მოლი გლდანი") }}
                </router-link>
              </slide-up-down>
            </div>
          </div>
        </div>

        <div
          v-if="
            $route.params.path1 !== 'about-us' &&
              $route.params.path1 !== 'card-loyal'
          "
          class="default-header__middle justify-center al-center flex container "
        >
          <transition-expand>
            <div
              v-if="
                selectedId &&
                  $mq != 'tablet' &&
                  $mq != 'phone' &&
                  $mq != 'xs' &&
                  !_.includes(_.get(childMenu, 'configs'), 'three-row-menu')
              "
              key="0"
              class="expanded-menu"
            >
              <div class="expanded-menu-container">
                <div
                  class="expanded-menu-inner container"
                  :class="{ more: _.size(_.get(childMenu, 'children')) > 1 }"
                >
                  <div
                    class="menu-item"
                    v-for="(item, index) in childMenu.children"
                    :key="index"
                  >
                    <router-link
                      tag="div"
                      class="pointer bold uppercase"
                      :to="_.get(item, 'full_url')"
                    >
                      {{ item.title }}
                    </router-link>
                    <div class="children" v-if="item.children">
                      <router-link
                        :to="_.get(child, 'full_url')"
                        tag="div"
                        class="menu uppercase bold pointer"
                        v-for="child in item.children"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </router-link>
                      <router-link
                        :to="_.get(item, 'full_url')"
                        tag="div"
                        class="menu uppercase font-13 bold pointer"
                      >
                        {{ $fn.tr("ყველას ნახვა") }}
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="image-cont"
                    v-if="
                      _.get(childMenu, 'media.optional_image.devices.desktop')
                    "
                  >
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.mobile'
                          )
                        "
                      />
                      <source
                        media="(max-width: 1023px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.tablet'
                          )
                        "
                      />
                      <img
                        :src="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.desktop'
                          )
                        "
                        alt
                      />
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <!-- layout for three-row-menu -->
            <div
              v-if="
                selectedId &&
                  $mq != 'tablet' &&
                  $mq != 'phone' &&
                  $mq != 'xs' &&
                  _.includes(_.get(childMenu, 'configs'), 'three-row-menu')
              "
              key="00"
              class="expanded-menu"
            >
              <div class="expanded-menu-container">
                <div
                  class="expanded-menu-inner container"
                  :class="{ more: _.size(_.get(childMenu, 'children')) > 1 }"
                >
                  <div class="menu-item" key="00">
                    <router-link
                      tag="div"
                      class="pointer bold uppercase"
                      :to="_.get(childMenu, 'children[0].full_url')"
                    >
                      {{ _.get(childMenu, "children[0].title") }}
                    </router-link>
                    <div
                      class="children"
                      v-if="_.get(childMenu, 'children[0].children')"
                    >
                      <router-link
                        v-for="child in _.get(
                          childMenu,
                          'children[0].children'
                        )"
                        :to="child.full_url"
                        tag="div"
                        class="menu uppercase bold pointer"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </router-link>
                      <router-link
                        :to="_.get(childMenu, 'children[0].full_url')"
                        tag="div"
                        class="menu uppercase font-13 bold pointer"
                      >
                        {{ $fn.tr("ყველას ნახვა") }}
                      </router-link>
                    </div>
                  </div>
                  <div class="menu-item">
                    <template
                      v-for="(item, index) in _.slice(
                        _.get(childMenu, 'children'),
                        1,
                        _.size(_.get(childMenu, 'children'))
                      )"
                    >
                      <router-link
                        v-if="!_.get(item, 'shortlink')"
                        :key="index"
                        tag="div"
                        :to="_.get(item, 'full_url')"
                        v-html="_.get(item, 'title')"
                      >
                      </router-link>
                      <a
                        v-else
                        :href="_.get(item, 'full_url')"
                        target="_blank"
                        class="pointer bold uppercase mb-6"
                        :key="index"
                        v-html="_.get(item, 'title')"
                      >
                      </a>
                    </template>

                    <!-- <div class="children" v-if="_.get(item, 'children')">
                      <router-link
                        :to="child.full_url"
                        tag="div"
                        class="menu uppercase bold pointer"
                        v-for="child in _.get(item, 'children')"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </router-link>
                      <router-link
                        :to="item.full_url"
                        tag="div"
                        class="menu uppercase font-13 bold pointer"
                      >
                        {{ $fn.tr("ყველას ნახვა") }}
                      </router-link>
                    </div> -->
                  </div>
                  <div
                    class="image-cont"
                    v-if="
                      _.get(childMenu, 'media.optional_image.devices.desktop')
                    "
                  >
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.mobile'
                          )
                        "
                      />
                      <source
                        media="(max-width: 1023px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.tablet'
                          )
                        "
                      />
                      <img
                        :src="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.desktop'
                          )
                        "
                        alt
                      />
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <!-- end layout -->
            <div
              v-if="
                category_list &&
                  $mq != 'tablet' &&
                  $mq != 'phone' &&
                  $mq != 'xs' &&
                  !_.includes(_.get(childMenu, 'configs'), 'three-row-menu')
              "
              key="1"
              class="expanded-menu"
            >
              <div class="expanded-menu-container">
                <div
                  class="expanded-menu-inner container"
                  :class="{
                    more: _.size(_.get(childMenu, 'children'))
                  }"
                >
                  <div class="menu-children-cont">
                    <router-link
                      v-if="_.get(shopMenuItem, 'full_url')"
                      tag="div"
                      :to="_.get(shopMenuItem, 'full_url')"
                      class="pointer bold mb-13 uppercase"
                    >
                      {{ $fn.tr("კატალოგი") }}
                    </router-link>
                    <MenuChildren
                      @shopMenu="setShopMenu"
                      :menuId="category_list"
                    />
                  </div>

                  <div class="list-content">
                    <template
                      v-for="(item, index) in _.get(childMenu, 'children')"
                    >
                      <router-link
                        v-if="!_.get(item, 'shortlink')"
                        tag="div"
                        :to="_.get(item, 'full_url')"
                        class="pointer lh-24 book uppercase"
                        :key="index"
                        v-html="item.title"
                      >
                        {{ item.title }}
                      </router-link>
                      <a
                        v-else
                        :href="_.get(item, 'full_url')"
                        target="_blank"
                        class="pointer lh-24 book uppercase"
                        :key="index"
                        v-html="item.title"
                      >
                        {{ item.title }}
                      </a>
                    </template>
                  </div>
                  <div class="image-cont">
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.mobile'
                          )
                        "
                      />
                      <source
                        media="(max-width: 1023px)"
                        :srcset="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.tablet'
                          )
                        "
                      />
                      <img
                        :src="
                          _.get(
                            childMenu,
                            'media.optional_image.devices.desktop'
                          )
                        "
                        alt
                      />
                    </picture>
                  </div>
                  <!-- <div class="menu-item pointer">test</div>
                  <div class="menu-item pointer">test</div>
                  <div class="menu-item pointer">test</div> -->
                </div>
              </div>
            </div>
          </transition-expand>
          <div
            class="outer-container"
            :class="{ active: selectedId || category_list }"
            @mouseover="closeMenu"
          ></div>

          <div
            class="
              default-header__middle__menu-item
              uppercase
              book
              flex
              al-center
            "
            v-for="(item, index) in _.get(menu, 'main')"
            :key="index"
            @click="clickMenuItem(item, true)"
            :class="{
              active: selectedId == item.id || category_list == item.id
            }"
          >
            <span
              class="uppercase book"
              @mouseover="clickMenuItem(item, false)"
            >
              {{ item.title }}
            </span>

            <svg
              v-if="item.children || _.includes(item.configs, 'has_children')"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>
        </div>

        <!-- <MenuChildren /> -->
      </div>

      <div
        v-if="
          $route.params.path1 !== 'about-us' &&
            $route.params.path1 !== 'card-loyal'
        "
        class="default-header__bottom al-center flex"
      >
        <div
          class="
            default-header__bottom__menu-item
            uppercase
            book
            flex
            al-center
          "
          v-for="(item, index) in menu.secondary"
          :key="index"
          @mouseover="clickMenuItemBlack(item, false)"
          @click="clickMenuItemBlack(item, true)"
          :class="{ last: index == menu.secondary.length - 1 }"
        >
          {{ item.title }}
          <svg
            v-if="item.children"
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="7.857"
            viewBox="0 0 10 7.857"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(17.5 -12) rotate(90)"
              fill="#ffffff"
            />
          </svg>
        </div>
        <transition-expand>
          <div
            v-if="
              selectedIdBlack &&
                $mq != 'tablet' &&
                $mq != 'phone' &&
                $mq != 'xs'
            "
            class="expanded-menu expanded-menu-black"
          >
            <div class="expanded-menu-container">
              <div
                class="expanded-menu-inner container"
                :class="{ more: _.size(childMenu.children) > 1 }"
              >
                <div
                  class="menu-item"
                  v-for="(item, index) in childMenu.children"
                  :key="index"
                >
                  <router-link
                    tag="div"
                    class="pointer bold uppercase"
                    :to="_.get(item, 'full_url')"
                  >
                    {{ item.title }}
                  </router-link>
                  <div class="children" v-if="item.children">
                    <template v-for="child in item.children">
                      <router-link
                        v-if="!_.get(child, 'shortlink')"
                        :to="_.get(child, 'full_url')"
                        tag="div"
                        class="menu uppercase bold pointer"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </router-link>
                      <a
                        v-else
                        :href="_.get(child, 'full_url')"
                        target="_blank"
                        class="menu uppercase bold pointer"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </a>
                    </template>

                    <router-link
                      :to="_.get(item, 'full_url')"
                      tag="div"
                      class="menu uppercase font-13 bold pointer"
                    >
                      {{ $fn.tr("ყველას ნახვა") }}
                    </router-link>
                  </div>
                </div>
                <div
                  class="image-cont"
                  v-if="
                    _.get(childMenu, 'media.optional_image.devices.desktop')
                  "
                >
                  <picture>
                    <source
                      media="(max-width: 767px)"
                      :srcset="
                        _.get(childMenu, 'media.optional_image.devices.mobile')
                      "
                    />
                    <source
                      media="(max-width: 1023px)"
                      :srcset="
                        _.get(childMenu, 'media.optional_image.devices.tablet')
                      "
                    />
                    <img
                      :src="
                        _.get(childMenu, 'media.optional_image.devices.desktop')
                      "
                      alt
                    />
                  </picture>
                </div>
                <!-- <div class="menu-item pointer">test</div>
                  <div class="menu-item pointer">test</div>
                  <div class="menu-item pointer">test</div> -->
              </div>
            </div>
          </div>
        </transition-expand>
        <div
          class="outer-container"
          :class="{ active: selectedIdBlack }"
          @mouseover="selectedIdBlack = null"
        ></div>
      </div>
      <transition name="show-search">
        <GlobalSearch
          :black_bar="
            $route.params.path1 !== 'about-us' &&
              $route.params.path1 !== 'card-loyal'
          "
          :transitionend="true"
          v-if="search_toggler"
        />
      </transition>
    </div>

    <div
      v-if="
        ($store.state.main.mallType &&
          $route.params.path1 !== 'about-us' &&
          $route.params.path1 !== 'card-loyal' &&
          $mq == 'tablet') ||
          $mq == 'phone' ||
          $mq == 'xs'
      "
      class="mobile-dropdown"
      :class="{ open: openMenu }"
    >
      <div class="mobile-dropdown__options flex al-center between">
        <div class="lang flex al-center" :class="{ active: languageOpen }">
          <div class="lang-row flex-box">
            <div
              class="selected-lang bold uppercase"
              @click="languageOpen = !languageOpen"
            >
              {{ _.get($store.state.main, "locale") === "ge" ? "Geo" : "Eng" }}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>

          <div class="change-lang-options" @click="changeLang">
            <router-link
              :to="''"
              tag="div"
              class="selected-lang bold uppercase"
            >
              {{ _.get($store.state.main, "locale") === "ge" ? "Eng" : "Geo" }}
            </router-link>
          </div>
        </div>
        <div class="default-header__search pointer" @click="toggle_search()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <path
              id="Path_3023"
              data-name="Path 3023"
              d="M19.556,17.383,15.433,13.26a8.231,8.231,0,0,0,1.491-4.8,8.312,8.312,0,0,0-.667-3.287A8.287,8.287,0,0,0,11.749.67a8.433,8.433,0,0,0-6.575,0A8.286,8.286,0,0,0,.667,5.177a8.433,8.433,0,0,0,0,6.574,8.289,8.289,0,0,0,4.507,4.507,8.315,8.315,0,0,0,3.287.667,8.232,8.232,0,0,0,4.8-1.49l4.123,4.111A1.428,1.428,0,0,0,18.462,20a1.538,1.538,0,0,0,1.094-2.62Zm-7.29-5.114a5.185,5.185,0,0,1-3.8,1.581,5.186,5.186,0,0,1-3.8-1.581,5.185,5.185,0,0,1-1.581-3.8,5.186,5.186,0,0,1,1.581-3.8,5.185,5.185,0,0,1,3.8-1.581,5.187,5.187,0,0,1,3.8,1.581,5.185,5.185,0,0,1,1.581,3.8A5.186,5.186,0,0,1,12.266,12.269Z"
              transform="translate(0 -0.003)"
              fill="#4d4d4f"
            />
          </svg>
        </div>
        <a
          :href="_.get(get360['button'], 'url')"
          target="_blank"
          class="link-360 bold pointer"
        >
          {{ _.get(get360["button"], "title") }}<span class="bold">&#176;</span>
        </a>
        <router-link
          tag="div"
          :to="mallUrl"
          class="location uppercase bold pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.505"
            height="16"
            viewBox="0 0 15.505 16"
          >
            <path
              id="Path_3184"
              data-name="Path 3184"
              d="M78.062,85.233v3.242h4.764l-4.4,4.545,2.371,2.447L85.2,90.922v4.916h3.142V85.233Zm0-5.395v3.243H90.425V95.838h2.268a.889.889,0,0,0,.875-.9V80.665a.815.815,0,0,0-.8-.827Z"
              transform="translate(-78.062 -79.838)"
              fill="#4d4d4f"
            />
          </svg>

          {{
            $route.params.path1 == "saburtalo"
              ? $fn.tr("გლდანი")
              : $fn.tr("საბურთალო")
          }}
        </router-link>
      </div>
      <div class="mobile-dropdown__main-menu">
        <div
          class="menu-items flex al-center pointer"
          v-for="(item, index) in menu.main"
          :key="index"
        >
          <div
            @click="clickMenuItem(item)"
            class="label uppercase bold"
            :class="{ open: item.id == selectedId || item.id == category_list }"
          >
            {{ item.title }}
            <svg
              v-if="
                _.size(item.children) ||
                  _.includes(item.configs, 'has_children')
              "
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#000000"
              />
            </svg>
          </div>

          <slide-up-down
            :active="item.id == selectedId"
            :duration="600"
            class="drodown-list"
          >
            <div
              class="menu-items uppercase bold flex al-center pointer"
              v-for="(item, index) in item.children"
              :key="index"
            >
              <router-link
                tag="div"
                class="pointer bold uppercase"
                :to="_.get(item, 'full_url')"
              >
                {{ item.title }}
              </router-link>
              <div class="children" v-if="item.children">
                <router-link
                  :to="_.get(child, 'full_url')"
                  tag="div"
                  class="menu uppercase pointer"
                  v-for="child in item.children"
                  :key="child.id"
                >
                  {{ child.title }}
                </router-link>
                <router-link
                  :to="_.get(item, 'full_url')"
                  tag="div"
                  class="menu uppercase font-13 bold pointer"
                >
                  {{ $fn.tr("ყველას ნახვა") }}
                </router-link>
              </div>
            </div>
          </slide-up-down>
          <slide-up-down
            :active="item.id == category_list"
            :duration="600"
            class="drodown-list"
          >
            <router-link
              v-if="_.get(shopMenuItem, 'full_url')"
              tag="div"
              :to="_.get(shopMenuItem, 'full_url')"
              class="pointer bold pt-13 uppercase"
            >
              {{ $fn.tr("კატალოგი") }}
            </router-link>
            <MenuChildren @shopMenu="setShopMenu" :menuId="category_list" />
            <template v-for="child in item.children">
              <router-link
                v-if="!_.get(child, 'shortlink')"
                tag="div"
                :to="_.get(child, 'full_url')"
                class="menu-items uppercase bold flex al-center pointer"
                :key="child.id"
                v-html="child.title"
              >
              </router-link>
              <a
                v-else
                :href="_.get(child, 'full_url')"
                class="menu-items uppercase bold flex al-center pointer"
                target="_blank"
                :key="child.id"
                v-html="child.title"
              ></a>
            </template>
          </slide-up-down>
        </div>
      </div>
      <div class="mobile-dropdown__secondary-menu">
        <div
          class="menu-items flex al-center pointer"
          v-for="(item, index) in menu.secondary"
          :key="index"
        >
          <div
            @click="clickMenuItem(item)"
            class="label uppercase bold"
            :class="{ open: item.id == selectedId }"
          >
            {{ item.title }}
            <svg
              v-if="item.children"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#ffffff"
              />
            </svg>
          </div>

          <slide-up-down
            :active="item.id == selectedId"
            :duration="600"
            class="drodown-list black"
          >
            <div
              class="menu-items uppercase bold flex al-center pointer"
              v-for="(item, index) in item.children"
              :key="index"
            >
              <router-link
                tag="div"
                class="pointer bold uppercase"
                :to="_.get(item, 'full_url')"
              >
                {{ item.title }}
              </router-link>
              <div class="children" v-if="item.children">
                <template v-for="child in item.children">
                  <router-link
                    v-if="!child.shortlink"
                    :to="_.get(child, 'full_url')"
                    tag="div"
                    class="menu uppercase pointer"
                    :key="child.id"
                  >
                    {{ child.title }}
                  </router-link>
                  <a
                    v-else
                    :href="child.full_url"
                    class="menu uppercase pointer"
                    target="_blank"
                    :key="child.id"
                    >{{ child.title }}</a
                  >
                </template>
                <router-link
                  key="111"
                  :to="_.get(item, 'full_url')"
                  tag="div"
                  class="menu uppercase font-13 bold pointer"
                >
                  {{ $fn.tr("ყველას ნახვა") }}
                </router-link>
              </div>
            </div>
          </slide-up-down>
        </div>
      </div>
    </div>

    <landing-header
      v-if="
        !$store.state.main.mallType &&
          $route.params.path1 !== 'about-us' &&
          $route.params.path1 !== 'card-loyal'
      "
    />
  </header>
</template>
<script>
import SvgComponents from "../SvgComponents.vue";
import LandingHeader from "./LandingHeader.vue";
import TransitionExpand from "../TransitionExpand.vue";
import GlobalSearch from "@/components/modules/GlobalSearch";
import MenuChildren from "@/components/modules/MenuChildren";
import main from "../../mixins/main";
import CardsDropdown from "../CardsDropdown.vue";

export default {
  components: {
    SvgComponents,
    LandingHeader,
    TransitionExpand,
    GlobalSearch,
    MenuChildren,
    CardsDropdown
  },
  mixins: [main],
  data() {
    return {
      openMenu: false,
      selectedId: null,
      languageOpen: false,
      scrolled: false,
      openMallDropdown: false,
      category_list: false,
      selectedIdBlack: null,
      offset: 0,
      shopMenuItem: null
    };
  },
  watch: {
    $route: {
      handler() {
        this.openMenu = false;
        this.selectedId = null;
        this.selectedIdBlack = null;
        this.category_list = false;

        if (this.search_toggler) {
          this.$store.commit("main/setState", {
            key: "global_search_beforeClose",
            val: false
          });

          setTimeout(() => {
            this.$store.commit("main/setState", {
              key: "global_search_toggler",
              val: false
            });
          }, 400);
        }
      }
    },
    hideChooser: {
      handler(val) {
        // console.log(val, 123);
      }
    },
    openMenu: {
      handler(val) {
        val
          ? (document.querySelector("html").style.overflow = "hidden")
          : (document.querySelector("html").style.overflow = "auto");
        // if(!val)this.toggle_search();
        if (!val)
          this.$store.commit("main/setState", {
            key: "global_search_toggler",
            val: false
          });
      }
    },
    offset: {
      handler(val) {
        if (val > 1) {
          this.closeMenu();
        }
      }
    },
    search_toggler(ns) {
      ns == true
        ? document.body.classList.add("ov_hidden")
        : document.body.classList.remove("ov_hidden");
    }
  },
  computed: {
    search_toggler() {
      return this.$store.state.main.global_search_toggler;
    },
    get360() {
      return this.$store.state.main.indx.widgets[360];
    },
    menu() {
      if (this.$route.params.path1 == "about-us" || !this.$route.params.path1) {
        return false;
      }
      const menu = this.makeMenuTree();
      const filteredMenu = menu.find(
        menu =>
          menu.url == this.$store.state.main.mallType &&
          !menu.configs.includes("hide-from-menu")
      );
      const selectedMenu = filteredMenu?.children;
      const mainMenu = selectedMenu?.filter(
        menu =>
          !menu.configs.includes("menu-secondary") &&
          !menu.configs.includes("hide-from-menu")
      );
      const secondaryMenu = selectedMenu?.filter(
        menu =>
          menu.configs.includes("menu-secondary") &&
          !menu.configs.includes("hide-from-menu")
      );

      return { main: mainMenu, secondary: secondaryMenu };
    },
    childMenu() {
      if (this.selectedId) {
        return this.menu.main.find(menu => menu.id == this.selectedId);
      } else if (this.selectedIdBlack) {
        return this.menu.secondary.find(
          menu => menu.id == this.selectedIdBlack
        );
      } else if (this.category_list) {
        return this.menu.main.find(menu => menu.id == this.category_list);
      }
    },
    mallUrl() {
      return this.$route.params.path1 == "saburtalo"
        ? `/${this.$store.state.main.locale}/gldani`
        : `/${this.$store.state.main.locale}/saburtalo`;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      this.openMallDropdown = false;
    },
    toggle_search() {
      if (this.search_toggler == false) {
        this.$store.commit("main/setState", {
          key: "global_search_toggler",
          val: true
        });
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      } else {
        this.$store.commit("main/setState", {
          key: "global_search_beforeClose",
          val: false
        });

        setTimeout(() => {
          this.$store.commit("main/setState", {
            key: "global_search_toggler",
            val: false
          });
        }, 400);
      }
    },

    closeMenus() {
      if (this.$mq == "tablet" || this.$mq == "phone" || this.$mq == "xs") {
        return false;
      }
      this.category_list = null;
      this.selectedIdBlack = null;
      this.selectedId = null;
    },
    clickMenuItem(menu, clickAction = true) {
      // console.log(menu, 'menu');
      // let targetHeight = document.getElementById("header-dropdown-container");
      // let targetHeight2 = document.querySelector(".dropdown-content.active");
      if (_.includes(menu.configs, "has_children")) {
        this.selectedId = null;
        this.selectedIdBlack = null;

        if (this.$mq == "tablet" || this.$mq == "phone" || this.$mq == "xs") {
          this.category_list == menu.id
            ? (this.category_list = null)
            : (this.category_list = menu.id);
        } else {
          this.category_list = menu.id;
        }

        // ? (this.category_list = null)
        // : (this.category_list = menu.id);
      } else {
        if (menu.children) {
          this.selectedIdBlack = null;
          this.category_list = null;
          this.selectedId == menu.id
            ? (this.selectedId = null)
            : (this.selectedId = menu.id);
        } else {
          this.selectedId = null;
          this.category_list = null;

          clickAction && _.get(menu, "shortlink")
            ? window.open(menu.full_url, "_blank")
            : clickAction && !_.get(menu, "shortlink")
            ? this.$router.push(menu.full_url)
            : "";
        }
      }
    },
    setShopMenu(el) {
      this.shopMenuItem = el ? el[0] : "";
    },
    clickMenuItemBlack(menu, clickAction = true) {
      if (_.size(menu.children)) {
        this.selectedId = null;
        this.selectedIdBlack == menu.id
          ? (this.selectedIdBlack = null)
          : (this.selectedIdBlack = menu.id);
      } else {
        this.selectedIdBlack = null;
        clickAction ? this.$router.push(menu.full_url) : "";
      }
    },
    changeLang() {
      this.languageOpen = false;
      const lang =
        _.get(this.$store.state.main, "locale") === "ge" ? "en" : "ge";
      setTimeout(() => {
        this.$router.push(this.$store.state.main?.selected_menu_locales[lang]);
      }, 200);
    },
    goToHome() {
      !this.$route.params.path2 || !this.$store.state.main.mallType
        ? this.$router.push(`/${this.$store.state.main.locale}/`)
        : this.$router.push(
            `/${this.$store.state.main.locale}/${this.$store.state.main.mallType}`
          );
    },
    scroll(e) {
      this.offset = window.scrollY;
      if (window.scrollY > 50) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    closeMenu() {
      this.selectedId = null;
      this.selectedIdBlack = null;
      this.category_list = false;
    },
    cursorChange(val) {
      if (
        !this.$store.state.main.mallType &&
        this.$route.params.path1 !== "about-us" &&
        this.$route.params.path1 !== "card-loyal"
      )
        this.$store.commit("main/setState", { key: "blackCursor", val: val });
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scroll);
  }
};
</script>
<style lang="scss">
.show-search {
  &-enter {
    transform: translateY(-100%);
    opacity: 0;
    transition: 0.6s;
    &-to {
      transform: translateY(0);
      transition: 0.6s;
      opacity: 1;
    }
  }
  &-leave {
    transform: translateY(0);
    transition: 0.6s;
    opacity: 1;

    &-to {
      transform: translateY(-100%);
      transition: 0.6s;
      opacity: 0;
    }
  }
}
</style>
<style lang="scss">
.list-content {
  sup {
    font-family: "Hm-Pangram-black";
    font-size: 10px;
  }
}
header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  background: #ffffff;
  position: relative;
  z-index: 999999991;
  &.landing {
    cursor: none;
  }
  // overflow: hidden;

  &:after {
    position: absolute;
    content: "";
    bottom: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(
      to right,
      #40adec 0%,
      #426ab3 20%,
      #3269e5 30%,
      #ffcb05 40%,
      #ffc900 50%,
      #ffc900 50%,
      #e11f26 60%,
      #e50b09 100%
    );
  }

  .default-header {
    width: 100%;
    &__top {
      height: 94px;
      border-bottom: 2px solid #f7f7f7;
      @media (max-width: 1439px) {
        height: auto;
        padding-top: 21px;
        padding-bottom: 21px;
      }
      @media (max-width: 1023px) {
        height: 64px;
        padding-top: 0;
        padding-bottom: 0;
      }

      .about-us-logo {
        left: 50%;
        transform: translate(-50%, 0px);
        position: absolute;
        &.mobile-logo {
          display: none;
        }
        @media (max-width: 1439px) {
          svg {
            width: 158px;
          }
        }
        @media (max-width: 767px) {
          svg {
            width: 150px;
          }
        }
        @media (max-width: 510px) {
          &:not(.mobile-logo) svg {
            height: 14px;
          }
        }
        @media (max-width: 413px) {
          display: none;
          &.mobile-logo {
            display: block;
          }
          &.mobile-logo svg {
            width: 50px;
          }
        }
      }
      &__top-left {
        @media (min-width: 1023px) {
          .burger {
            display: none;
          }
        }
        .burger {
          cursor: pointer;
          &.open {
            .burger-item {
              &:first-child {
                transform: translate(0px, 5px) rotate(45deg);
              }
              &:last-child {
                transform: translate(0px, -8px) rotate(-45deg);
              }
            }
          }
          &::after {
            content: unset;
          }
          .burger-item {
            width: 25px;
            height: 3px;
            background: $black;
            transition: 0.4s ease;
            &:first-child {
              margin-bottom: 10px;
            }
          }
        }
        @media (max-width: 1023px) {
          .lang,
          .link-360,
          svg {
            display: none;
          }
        }
        > * {
          &:nth-child(2) {
            // margin-left: 0;
          }
        }
        .lang {
          cursor: pointer;
          flex-direction: column;
          position: relative;

          .lang-row {
            display: flex;
            align-items: center;
            svg {
              margin-left: 5px;
            }
          }

          .change-lang-options {
            opacity: 0;
            position: absolute;
            top: 20px;
            left: 2px;
            visibility: hidden;
            max-height: 0;
            transition: 0.6s ease;
          }
          svg {
            transition: 0.4s ease-in-out;
          }
          &.active {
            .change-lang-options {
              opacity: 1;
              visibility: visible;
              max-height: 100px;
            }
            svg {
              transform: rotate(180deg);
            }
          }
        }

        .link-360 {
          text-decoration: underline;
          cursor: pointer;
          color: $black;
        }
        > * {
          position: relative;
          margin-right: 20px;
          margin-left: 20px;
          &:first-child {
            margin-left: 0px;
          }
          &::after {
            position: absolute;
            content: "";
            display: block;
            right: -20px;
            width: 2px;
            top: 0;
            height: 14px;
            top: 50%;
            transform: translate(0, -50%);
            background: rgba(77, 77, 79, 0.3);
            @media (max-width: 1023px) {
              content: unset;
            }
          }
          @media (max-width: 767px) {
            margin-right: 10px;
            margin-left: 10px;
          }
        }
      }
      &__top-right {
        .location {
          cursor: pointer;
          display: flex;
          @media (max-width: 1023px) {
            display: none;
          }
          svg {
            margin-right: 10px;
            transition: 0.2s ease;
            will-change: transform;
          }
          &:hover {
            svg {
              transform: rotate(45deg);
            }
          }
        }
        .desktop-switcher {
          color: $black;
          display: block;
          transition: 0.2s ease;
          @media (max-width: 1365px) {
            display: none;
          }
          &:hover {
            color: $red;
          }
        }
        .mobile-switcher {
          display: none;
          transition: 0.2s ease;

          @media (max-width: 1365px) {
            display: block;
          }
          &:hover {
            color: $red;
          }
        }
        .cards {
          @media (max-width: 1023px) {
            &.about-card {
              display: none;
            }
          }
          @media (max-width: 767px) {
            margin-right: 0px;
          }
          .label {
            @media (max-width: 767px) {
              display: none;
            }
            margin: 0 10px;
          }
          .flex {
            @media (max-width: 767px) {
              margin-right: 5px;
            }
          }
        }
        .choose-mall {
          .label {
            svg {
              transition: 0.4s ease;
            }

            &.open {
              svg {
                transform: rotate(180deg);
              }
            }
          }
          .dropdown {
            .location {
              display: flex;
              justify-content: flex-end;
            }
            position: absolute;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-end;
            min-width: 250px;
            right: 0;
            top: 19px;
            z-index: 1;
          }
        }
        > div {
          position: relative;
          margin-right: 20px;
          margin-left: 20px;
          &:last-child {
            margin-right: 0px;
            @media (max-width: 767px) {
              margin-left: 10px;
            }
          }
          &:not(:first-child) {
            &::after {
              @media (max-width: 767px) {
                content: unset;
              }
              position: absolute;
              content: "";
              display: block;
              left: -20px;
              width: 2px;
              top: 0;
              height: 14px;
              top: 50%;
              transform: translate(0, -50%);
              background: rgba(77, 77, 79, 0.3);
            }
          }
        }
      }
    }
    &__middle {
      height: 55px;
      background: $white;
      transition: 0.4s ease;
      @media (max-width: 1439px) {
        /* height: 55px; */
        padding-top: 21px;
        padding-bottom: 21px;
      }
      &__menu-item {
        &:not(:last-child) {
          margin-right: 55px;
        }
        span {
          &:hover {
            color: $red;
            ~ svg {
              path {
                fill: $red;
              }
            }
          }
        }

        &.active {
          svg {
            transform: rotate(180deg);
          }
        }
        svg {
          transition: 0.4s ease;
          path {
            transition: 0.4s ease;
          }
        }
      }

      @media (max-width: 1441px) {
        justify-content: space-between;
      }
      @media (max-width: 1023px) {
        display: none;
      }
      &__menu-item {
        cursor: pointer;
        svg {
          margin-left: 10px;
        }
      }
    }
    &__bottom {
      height: 45px;
      background: $black;
      justify-content: center;
      top: 150px;
      z-index: 999;
      position: absolute;
      width: 100%;
      @media (max-width: 1439px) {
        top: 120px;
      }
      @media (max-width: 1023px) {
        display: none;
      }
      &__menu-item {
        cursor: pointer;
        color: $orange;
        transition: 0.4s ease;

        &:hover {
          color: $blue;
          svg {
            transform: rotate(180deg);

            path {
              fill: $blue;
            }
          }
        }
        svg {
          transition: 0.4s ease;
          margin-left: 10px;
        }
        &.active {
          svg {
            transform: rotate(180deg);
          }
        }
        &:not(:last-child) {
          margin-right: 100px;
        }
        &.last {
          margin-right: 0;
        }
      }
    }
    &__search {
      svg path {
        transition: 0.4s;
      }
      @include hover {
        svg path {
          fill: $blue;
        }
      }
    }
    .expanded-menu {
      position: fixed;
      top: 139px;
      left: 0;
      width: 100%;
      overflow: hidden;
      z-index: 9999999;
      @media (max-width: 1439px) {
        top: 122px;
      }
      @media (max-width: 1023px) {
        display: none;
      }
      .expanded-menu-container {
        background: $white;
        width: 100%;
      }
      .expanded-menu-inner {
        width: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0px, auto));
        grid-gap: 30px;
        justify-content: space-between;

        &.more {
          grid-template-columns: repeat(3, minmax(0px, auto));
        }
        .list-content {
          width: 400px;
          .bold {
            color: $black;
          }
        }
        .image-cont {
          position: relative;
          width: 466px;
          height: 300px;
          img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .menu-item {
          margin-bottom: 10px;
          .children {
            margin-top: 13px;
            .menu {
              color: #4d4d4f;
              margin: 5px 0;
              transition: 0.4s ease;
              font-size: 13px;

              &:hover {
                color: $red;
              }
              &:last-child {
                &:hover {
                  color: $red;
                }
                color: rgba(77, 77, 79, 0.6);
              }
            }
          }
        }
      }
      &.expanded-menu-black {
        top: 195px;
        @media (max-width: 1439px) {
          top: 165px;
        }

        .expanded-menu-container {
          background: #252a30;
        }
        .expanded-menu-inner {
          .menu-item {
            color: $white;
            .menu {
              color: #bebfc1;
              font-size: 13px;
              &:hover {
                color: $white;
              }
              &:last-child {
                &:hover {
                  color: $white;
                }
                color: rgba(190, 191, 193, 0.6);
              }
            }
          }
        }
      }
    }
    .outer-container {
      width: 100vw;
      height: calc(100vh - 150px);
      // height: 100%;

      position: absolute;
      overflow: hidden;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      visibility: hidden;
      top: 170px;
      left: 0;

      transition: 1s ease;
      &.active {
        opacity: 1;
        visibility: visible;
      }
    }
    .fixed {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 99999999;
      background: $white;
      // position: relative;
      &:after {
        transition: 0.2s ease;
        position: absolute;
        content: "";
        width: 0vw;
        height: 2px;
        background: linear-gradient(
          to right,
          #40adec 0%,
          #426ab3 20%,
          #3269e5 30%,
          #ffcb05 40%,
          #ffc900 50%,
          #ffc900 50%,
          #e11f26 60%,
          #e50b09 100%
        );
      }
      &.scrolled {
        &:after {
          width: 100vw;
        }
      }
    }
    .label {
      svg {
        transition: 0.5s ease;
      }
      &.open {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  .mobile-dropdown {
    position: fixed;
    top: 64px;
    width: 100%;
    height: calc(100vh - 64px);
    overflow: auto;
    opacity: 0;
    visibility: hidden;
    z-index: 999999;
    transition: 0.4s ease;
    background: #1a1a1a;

    .menu-items {
      color: $black;
      .label {
        transition: 0.4s ease;
        svg {
          path {
            transition: 0.4s ease;
          }
        }
        &.open {
          color: $red;
          svg {
            path {
              fill: $red;
            }
          }
        }
      }
    }
    .drodown-list {
      &.black {
        .menu {
          color: $white;
          &:last-child {
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }
      .menu {
        color: #4d4d4f;
        font-size: 13px;
        line-height: 21px;
        &:last-child {
          color: rgba(77, 77, 79, 0.6);
        }
      }
      .menu-items {
        .uppercase {
          font-size: 13px;
        }
        &:first-child {
          padding-bottom: 0px;
        }
      }
    }
    &.open {
      opacity: 1;
      visibility: visible;
    }
    .label {
      svg {
        transition: 0.5s ease;
      }
      &.open {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .lang {
      cursor: pointer;
      flex-direction: column;
      position: relative;
      margin-left: 0;

      .lang-row {
        display: flex;
        align-items: center;
      }

      .change-lang-options {
        opacity: 0;
        position: absolute;
        top: 20px;
        left: 2px;
        visibility: hidden;
        max-height: 0;
        transition: 0.6s ease;
      }
      svg {
        transition: 0.4s ease-in-out;
      }
      &.active {
        .change-lang-options {
          opacity: 1;
          visibility: visible;
          max-height: 100px;
        }
        svg {
          transform: rotate(180deg);
        }
      }
    }
    &__main-menu {
      background: #f7f7f7;
      padding: 30px 45px;

      @media (max-width: 767px) {
        padding: 30px 15px;
      }
      .menu-items {
        padding-bottom: 13px;
        padding-top: 13px;
        border-bottom: 1px solid rgba(77, 77, 79, 0.05);
        flex-direction: column;
        align-items: flex-start;
        .drodown-list {
          .menu-items {
            border-bottom: unset;
            display: block;
          }
        }

        svg {
          margin-left: 10px;
        }
      }
    }
    &__secondary-menu {
      background: $black;
      padding: 30px 45px;
      .menu-items {
        .label {
          transition: 0.4s ease;

          &.open {
            color: $blue;
            svg {
              path {
                fill: $blue;
              }
            }
          }
        }
      }
      @media (max-width: 767px) {
        padding: 30px 15px;
      }

      .menu-items {
        padding-bottom: 13px;
        padding-top: 13px;
        color: $white;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        flex-direction: column;
        align-items: flex-start;
        .drodown-list {
          .menu-items {
            border-bottom: unset;
          }
        }
        svg {
          margin-left: 10px;
        }
      }
    }
    &__options {
      padding: 35px 45px;
      background: #f7f7f7;
      @media (max-width: 767px) {
        padding: 35px 15px;
      }
      .link-360 {
        text-decoration: underline;
        color: $black;
      }
      .location {
        svg {
          margin-right: 10px;
        }
      }
    }
  }

  .cards {
    position: relative;
    a {
      color: #1a1a1a;
      transition: 0.4s;
      @include hover {
        color: #e50b09;
      }
    }
    &__card-links {
      position: absolute;
      top: 40px;
      left: 0;
      background-color: white;
      padding-top: 30px;
      padding-bottom: 30px;
      padding-left: 34px;
      padding-right: 34px;
      width: fit-content;
      white-space: nowrap;
      will-change: transform;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 20px;
      z-index: 10;
      @media (max-width: 1280px) {
        left: -90px;
      }
      @media (max-width: 767px) {
        left: -190px;
      }
      @media (max-width: 413px) {
        left: -170px;
      }
    }
    &__card-link:nth-child(1) {
      border-bottom: #e6e6e6 1px solid;
    }
  }

  .cards-links-dropdown {
    &-enter {
      opacity: 0;
      transform: translateY(20%);
      transition: ease-out 0.4s;
    }

    &-enter-to {
      opacity: 1;
      transform: translateY(0);
      transition: ease-out 0.4s;
    }
    &-leave {
      opacity: 1;
      transform: translateY(0);

      transition: ease-in-out 0.4s;
    }
    &-leave-to {
      opacity: 0;
      transition: ease-in-out 0.4s;
      transform: translateY(20%);
    }
  }
}
</style>
